import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, bonusValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-border bg-surface py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxijbwru64m">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop9g9ffbfok">The {totalBonuses} <span className="text-accent" data-id="element-21" data-mp="15q5itvpvxfpv">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-xl border border-border bg-background shadow-sm" data-id="element-22" data-mp="1jgiqry2s0uf7">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-border p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="r0gexsqeqxlw" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary" data-id="element-24" data-mp="2jhcwx12s7k2g">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2ofo5l8hcboj3" />
                </span>
                <div data-id="element-26" data-mp="1quabnan495u5">
                  <p className="text-sm font-semibold text-accent" data-id="element-27" data-mp="1qus4dxakl1xb">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-semibold leading-snug text-foreground" data-id="element-28" data-mp="1vt3gkeoc7oip">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-29" data-mp="20ptv2xkhuc20">{bonus.description}</p>
                  <p className="mt-2 flex items-center gap-2 text-sm" data-id="element-30" data-mp="25s2n9rpjla32">
                    <span className="text-muted line-through decoration-accent decoration-2" data-id="element-31" data-mp="3c5ifbh6d4wz4">{bonusValue}</span>
                    <span className="font-bold text-accent" data-id="element-32" data-mp="3h4btzcxdyu0v">FREE</span>
                  </p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-xl border border-accent/40 bg-background px-6 py-6 text-center shadow-sm sm:flex-row sm:text-left" data-id="element-33" data-mp="1c4kiul2odgkh">
          <div data-id="element-34" data-mp="1m2i6p7gmhbck">
            <p className="text-sm font-medium text-muted" data-id="element-35" data-mp="1m1yodpn28ky0">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-muted line-through decoration-accent decoration-2" data-id="element-36" data-mp="ycnsomkkhgqq">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-37" data-mp="1757ntd1nh36t">
            <p className="text-sm font-medium text-muted" data-id="element-38" data-mp="17697g5wqey05">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-accent" data-id="element-39" data-mp="12dzc2acul5qh">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-40" data-mp="eo54a77dy7d3" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}